import React from "react"
import gql from "graphql-tag"
import { Query } from "react-apollo"

const getModelQuery = gql`
  query getModelQuery($slug: String) {
    getModel(slug: $slug) {
      id
      workspaceId
      displayName
      dataset
      slug
      favoriteType
      product {
        id
        slug
        available
        isPurchased
        isSpecialAccess
      }
      embedToken {
        id
        token
        expiration
      }
    }
  }
`

const GetModelQuery = (props) => {
  const { children, variables } = props

  return (
    <Query query={getModelQuery} variables={variables}>
      {(queryResult) => {
        return children(queryResult)
      }}
    </Query>
  )
}

export default GetModelQuery
